<template>
  <div class="product-card">
    <!-- 产品图片区域 -->
    <div class="product-image">
      <el-image
        v-if="productImage"
        class="image"
        :src="productImage"
        fit="cover"
        :preview-src-list="[productImage]"
        @click.stop
      />
      <img v-else src="../../../../../assets/images/default.png" class="image" />
      <!-- 倒计时 -->
      <!-- <div class="countdown" v-if="validEndTime" :key="validEndTime">
        {{ validEndTime }}
      </div> -->
      <!-- <div class="copy-icon" @click.stop="copyHandle">
        <img src="../../../../../assets/images/copy.png" />
      </div> -->
    </div>
    <div class="product-info-footer">
      <div class="product-name">{{ productName }}</div>
      <div class="product-action" v-if="showReserveButton">
        <el-button type="primary" size="small" @click.stop="$emit('toReserve')">下单量预约</el-button>
      </div>
    </div>
    <!-- <div>
      <div class="product-info">
        <div class="live-info">
          <div class="live-room">
            <img v-if="product.platformLogo" :src="product.platformLogo" class="live-icon" />
            {{ product.categoryName }} {{ product.brandName }} {{ product.productName }}
            <span>{{ product.activityMechanism || ''}}</span>
          </div>
        </div>
        
        <div class="expiry-time">
          <span v-if="sortType === 2">
            失效时间：{{ computedTime(product.activityEndTime) }}
          </span>
        </div>
      </div>
      
      <div class="price-info">
        <div class="item">
          <div class="label">参考价</div>
          <div class="value" v-if="product.priceHidden">**</div>
          <div class="value" v-else><span class="unit">¥</span>{{ product.referencePrice || 0 }}</div>
        </div>
        <div class="item">
          <div class="label">约返佣金</div>
          <div class="value" v-if="product.priceHidden">**</div>
          <div class="value" v-else>
            <span class="unit">¥</span>{{ product.promotionAmount || 0 }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import { copyFn } from '@/utils/util'
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    sortType: {
      type: Number,
      default: 2
    },
    roleType: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    productImage() {
      return this.product.productImage || this.product.productMainImage || ''
    },
    productName() {
      return [this.product.categoryName, this.product.brandName, this.product.productName]
        .filter(item => item)
        .join(' ')
    },
    showReserveButton() {
      if (this.roleType == null || this.roleType === '') return false
      return this.roleType != 4
    }
  },
  data() {
    return {
      validEndTime: ''
    }
  },
  created () {
    this.initValidTime()
  },
  methods: {
    copyHandle () {
      // this.$emit('copy')
      const name = [this.product.categoryName, this.product.brandName, this.product.productName].filter(item => item).join(' ')
      copyFn(`【商品名称】${name}\n【商品ID】${this.product.id || '--'}\n【活动机制】${this.product.activityMechanism || '--'}\n【参考价】${this.product.priceHidden ? '**' : (this.product.referencePrice || 0) + '元' }\n【下单链接】${this.product.productLink || '--'}\n【活动结束时间】${this.computedTime(this.product.activityEndTime) || '--'}\n【报单截止时间】${this.product.reportEndTime ? moment(this.product.reportEndTime).format('YYYY-MM-DD HH:mm:ss') : '--'}\n【下单说明】${this.product.orderDescription || '--'}`, () => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
    },
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    initValidTime () {
      if (!this.product.activityEndTime) {
        return
      }
      this.interval = setInterval(() => {
        this.validEndTime = this.computedValidTime(this.product.activityEndTime)
      }, 1000)
    },
    computedValidTime (date) {
      if (!date) {
        return ''
      }

      // 如果已过期，返回“已结束”
      if (moment().isAfter(moment(date))) {
        return '已结束'
      }

      const diff = moment.duration(moment(date).diff(moment()))
      const days = Math.floor(diff.asDays())
      const hours = diff.hours()
      const minutes = diff.minutes()
      const seconds = diff.seconds()
      if (days > 0) {
        return `仅剩${days}天${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      } else if (hours > 0) {
        return `仅剩${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      } else if (minutes > 0) {
        return `仅剩${minutes}:${String(seconds).padStart(2, '0')}`
      } else {
        return `仅剩${seconds}秒`
      }
    }
  }
}
</script>

<style scoped>
.product-card {
  position: relative;
  width: 100%;
  border-radius: 2px; 
  overflow: hidden;
  background-color: #fff;
}

.product-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  overflow: hidden;
  border-radius: 2px;
}

.product-image .image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  object-fit: cover;
}

.product-image .image ::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.countdown {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(10, 10, 10, 0.6);
  color: #fff;
  padding: 4px 8px;
  border-radius: 2px;
  font-size: 12px;
}

.product-info-footer {
  padding: 8px 0 0;
}

.product-name {
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  color: #333;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 8px;
}

.product-action {
  width: 100%;
}

.product-action ::v-deep .el-button {
  width: 100%;
  height: 32px;
  padding: 0;
  line-height: 32px;
  font-size: 12px;
}

.product-info {
  padding: 8px 0;
  display: flex;
  flex-wrap: wrap;
}

.live-info { 
  margin-bottom: 8px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 700;
  height: 32px;
  overflow: hidden;
}

.live-icon {
  margin-top: 2px;
  width: 12px;
  height: 12px;
  vertical-align: top;
  margin-right: 4px;
}

.live-room {
  color: #9266FF;
  line-height: 16px;
  border-radius: 2px;
  font-size: 12px; 
  overflow: hidden;
  font-weight: bold; 
  display: inline-block;
}
.live-room span {
  color: #000;
}

.product-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 1.4;
}

.expiry-time {
  font-size: 12px;
  color: #999;
}

.price-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px; 
  background-color: #EEE3FF;
}
.price-info .item {
  padding: 2px 6px;
  color: #753DFF;
  flex: 1;
}
.price-info .item:last-child {
  color: #fff;
  background-color: #764CFF;
}

.price-info .item .label {
  line-height: 14px;
  font-size: 12px; 
}

.price-info .item .value {
  line-height: 18px;
  font-size: 16px;
  font-weight: 500;
}
.price-info .item .value .unit {
  font-size: 12px;
  font-weight: normal;
}

.copy-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
}
.copy-icon img {
  cursor: pointer;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
